<template>
    <v-dialog v-model="modal" :scrim="false" width="500">
        <v-card>
            <v-icon class="v-card-close" @click="modal = false">mdi-close</v-icon>
            <v-card-title class="text-h6 font-weight-light">
                {{ $t('cancellation') }}
            </v-card-title>
            <v-card-text>
                <div v-html="isB2B ? $t('cancellation_order_text_b2b') : $t('cancellation_order_text_b2c')" />
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn @click="modal = false">
                    {{ $t('close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class CancelServiceManualModal extends Vue {
        modal = false

        async show() {
            this.modal = true
        }

        get isB2B() {
            return authStore.isB2B
        }
    }

    export default CancelServiceManualModal
</script>
